import type { Adventure } from '../../types'

// Shape Patterns Adventure - Age 4 - Repeating patterns with shapes
export const tillyShapePatternCorrect = [
  "Perfect pattern! You know what's next!",
  "That's right! The pattern continues!",
  "Wonderful! You see the pattern!",
  "Excellent! What's next comes naturally!",
  "Yes! The shapes repeat perfectly!",
  "Brilliant pattern recognition!",
  "You got it! Keep the pattern going!",
  "Super job! You understand patterns!",
  "Pattern master! That's correct!",
  "Fantastic! You see how it repeats!"
]

export const tillyShapePatternWrong = [
  "Look at the pattern again! What comes after this shape?",
  "Almost! Watch the shapes repeat!",
  "Try again! Which shape comes next in the pattern?",
  "So close! Look for the repeating part!",
  "Good try! Find what repeats!",
  "Look carefully - circle, square, circle, square... what is next?",
  "You're learning! Follow the pattern!",
  "Try matching the next shape in line!",
  "Think about what comes next!",
  "Patterns repeat! What shape comes again?"
]

export const shapePatternsAdventure: Adventure = {
  id: 'shape-patterns',
  title: 'Shape Patterns',
  theme: 'patterns',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 9,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello pattern explorer! I am Tilly! Patterns are everywhere! Let's find out what comes next in a pattern!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look: circle, square, circle, square... See how it repeats? Circle comes next! Can you spot patterns?",
      duration: 5
    },
    choice1: [
      {
        id: 'continue',
        label: 'Continue the pattern!',
        tillyLine: "Let's see what comes next!",
        nextState: 'quiz-1'
      },
      {
        id: 'make',
        label: 'Make my own!',
        tillyLine: "Creating patterns is fun too!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'pattern-complete',
      question: 'What comes next? 🔴, 🔵, 🔴, 🔵, ?',
      tillyPrompt: 'Look at the pattern! What repeats?',
      options: [
        { id: 'red', label: '🔴 Red', isCorrect: true },
        { id: 'blue', label: '🔵 Blue', isCorrect: false },
        { id: 'yellow', label: '🟡 Yellow', isCorrect: false }
      ],
      pattern: [1, 2, 1, 2],
      correctAnswer: 1
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Excellent! Now let's try ABAB patterns with different shapes! Triangle, circle, triangle, circle...",
      duration: 4
    },
    choice2: [
      {
        id: 'shapes',
        label: 'Shape patterns!',
        tillyLine: "Shapes make great patterns!",
        nextState: 'quiz-2'
      },
      {
        id: 'colors',
        label: 'Color patterns!',
        tillyLine: "Colors can make patterns too!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'pattern-complete',
      question: 'What comes next? 🔺, ⭐, 🔺, ⭐, ?',
      tillyPrompt: 'Triangle, star, triangle, star... what is next?',
      options: [
        { id: 'circle', label: '🔵 Circle', isCorrect: false },
        { id: 'triangle', label: '🔺 Triangle', isCorrect: true },
        { id: 'star', label: '⭐ Star', isCorrect: false }
      ],
      pattern: [1, 2, 1, 2],
      correctAnswer: 1
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Pattern genius! Challenge Round: ABB and ABC patterns! These are trickier!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'pattern-complete',
          question: 'ABB pattern: 🔴, 🟡, 🟡, 🔴, 🟡, ?',
          tillyPrompt: 'Two yellows together! What comes next?',
          options: [
            { id: 'red', label: '🔴 Red', isCorrect: false },
            { id: 'yellow', label: '🟡 Yellow', isCorrect: true },
            { id: 'blue', label: '🔵 Blue', isCorrect: false }
          ],
          pattern: [1, 2, 2, 1, 2],
          correctAnswer: 2
        } as any,
        {
          id: 'challenge-2',
          type: 'pattern-complete',
          question: 'ABC pattern: 🔵, 🟢, 🟡, 🔵, 🟢, ?',
          tillyPrompt: 'Three different colors repeat! What is next?',
          options: [
            { id: 'blue', label: '🔵 Blue', isCorrect: false },
            { id: 'green', label: '🟢 Green', isCorrect: false },
            { id: 'yellow', label: '🟡 Yellow', isCorrect: true }
          ],
          pattern: [1, 2, 3, 1, 2],
          correctAnswer: 3
        } as any,
        {
          id: 'challenge-3',
          type: 'pattern-complete',
          question: 'Missing middle: 🔴, ?, 🔴, ?, 🔴 What fills the gaps?',
          tillyPrompt: 'Something between the reds!',
          options: [
            { id: 'yellow', label: '🟡 Yellow', isCorrect: true },
            { id: 'red', label: '🔴 Red', isCorrect: false },
            { id: 'green', label: '🟢 Green', isCorrect: false }
          ],
          pattern: [1, 2, 1, 2, 1],
          correctAnswer: 2
        } as any
      ]
    },
    reward: {
      tillyLine: "Outstanding! You're a Pattern Master! You can spot any repeating pattern!",
      badgeName: 'Pattern Master',
      badgeIcon: '🔁',
      nextPreview: 'Next time, we will learn first, second, third!'
    }
  }
}
